import { render, staticRenderFns } from "./order.vue?vue&type=template&id=4529ba90&scoped=true&"
import script from "@/service/orderservice.js?vue&type=script&charset=utf-8&lang=js&"
export * from "@/service/orderservice.js?vue&type=script&charset=utf-8&lang=js&"
import style0 from "./order.vue?vue&type=style&index=0&id=4529ba90&lang=scss&scoped=true&"
import style1 from "./order.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4529ba90",
  null
  
)

export default component.exports